import { isEqual } from 'lodash';

const getStorageVars = (storageKey: string) => {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  const existingStorageString = localStorage.getItem(storageKey);
  try {
    const existingStorage: Record<string, string> | null = existingStorageString
      ? JSON.parse(existingStorageString)
      : null;
    return existingStorage;
  } catch (error) {
    console.error(`Error parsing storage item "${storageKey}":`, error);
    return null;
  }
};

export const configureStorageVars = <T>(
  previousKey: string,
  storageKey: string,
  originalVars: Record<string, T>,
  shouldResetIfChanged: boolean,
) => {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  const previousVars = getStorageVars(previousKey);

  if (isEqual(originalVars, previousVars)) {
    // Vars haven't been changed externally so we're safe to early return
    return;
  }
  // If vars have been changed externally then reset our
  // stored vars
  if (shouldResetIfChanged) {
    const jsonString = JSON.stringify(originalVars);
    localStorage?.setItem(storageKey, jsonString);
    localStorage?.setItem(previousKey, jsonString);
  }
};
